import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[IconConstants]" }] */
import IconConstants from 'components/shared/icons/IconConstants';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('Icons')
class CrossIconContainer extends React.Component {
  render() {
    return <CrossIcon {...this.props} />;
  }
}

class CrossIcon extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
    strokeWidth: PropTypes.number,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    color: IconConstants.WHITE,
    size: 16,
    strokeWidth: 2,
  };

  render() {
    const {
      className,
      color,
      size,
      strokeWidth,
    } = this.props;
    const { getString } = this.context;

    return (
      /* eslint-disable max-len */
      <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 16 16"
        role="img"
        aria-label={getString('AA_Cross_Icon_Desc')}
      >
        <title>{getString('AA_Cross_Icon_Title')}</title>
        <desc>{getString('AA_Cross_Icon_Desc')}</desc>
        <path
          role="presentation"
          stroke={color}
          strokeWidth={strokeWidth}
          d="M8,8 L1.56501037,14.4349896 L8,8 L1.56501037,1.56501037 L8,8 Z M8,8 L14.5316759,1.46832408 L8,8 L14.5316759,14.5316759 L8,8 Z"
        />
      </svg>
      /* eslint-enable */
    );
  }
}

export default CrossIconContainer;
